
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/ortto",
      function () {
        return require("private-next-pages/destinations/ortto.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/ortto"])
      });
    }
  